import { type ApiResponse, ApiFactory } from '@/utils/api'
import type { UserRoleInStoreReqType, GoodsVisible } from '@/models/types/dropdown.type'
import { DropdownEnum } from '@/constants/enums/api/dropdown.enums'

export class DropdownServices extends ApiFactory {
  constructor() {
    super('')
  }

  /** 取得可用機台群組  */
  getGroupsDDL = async (): Promise<ApiResponse> => {
    return await this.get<unknown, ApiResponse>(DropdownEnum.getGroupsDDL)
  }

  /** 取得可用商品群組 */
  getGoods = async (): Promise<ApiResponse> => {
    return await this.get<unknown, ApiResponse>(DropdownEnum.getGoods)
  }

  /** 取得其他業主商品池 */
  getOtherGoodsPool = async (params: { incluingInvisible: boolean }): Promise<ApiResponse> => {
    return await this.get<unknown, ApiResponse>(DropdownEnum.getOtherGoodsPool, params)
  }

  /** 取得權限設定 */
  userRoleInStore = async (storeId: UserRoleInStoreReqType): Promise<ApiResponse> => {
    return await this.get<unknown, ApiResponse>(DropdownEnum.userRoleInStore, storeId)
  }

  /** 取得可用店家 */
  getStores = async () => {
    return await this.get<unknown, ApiResponse>(DropdownEnum.getStores)
  }

  /** 取得商品下拉清單 */
  getGoodsDDL = () => {
    return this.get<unknown, ApiResponse>(DropdownEnum.getGoodsDDL)
  }

  /** 設定商品隱藏/可見 */
  setIsVisible = async (params: GoodsVisible) => {
    return await this.put<GoodsVisible, ApiResponse>(DropdownEnum.setIsVisible, params)
  }

  /** 設定商品隱藏/可見-其他業主商品池 */
  setIsVisibleOnOtherPool = async (params: GoodsVisible) => {
    return await this.put<GoodsVisible, ApiResponse>(DropdownEnum.setIsVisibleOnOtherPool, params)
  }

  /** 取得店家商品編輯紀錄總攬 */
  getGoodsPoolModifiedRecords = async (params: { index: number }, abortSignal?: AbortSignal) => {
    return await this.get<unknown, ApiResponse>(DropdownEnum.getGoodsPoolModifiedRecords, params, {
      signal: abortSignal
    })
  }
}
